module.exports = __webpack_public_path__ + "static/media/ProjectInactive.db619cb4.png";